




import { Component, Vue } from 'vue-property-decorator'
import UserDetail from './components/UserDetail.vue'

@Component({
  name: 'EditUser',
  components: {
    UserDetail
  }
})
export default class extends Vue {}
